export default __webpack_public_path__ + "source-sans-pro-v13-latin_latin-ext-600.3acdedcc1defd70c55ef9a1dc6fed75f.woff2";